import React from 'react';
import { Answer } from '../../../../types';
import { OptionsContainer, OptionCard, OptionIcon, OptionText } from './styles';
import { getOptionLabel } from '../../utils/utils';
import checkIcon from 'img/check.svg';
import timesIcon from 'img/times-white.svg';

interface AnswerOptionsProps {
  answers: Answer[];
  selectedOption: number | null;
  onOptionClick: (optionId: number) => void;
  showResults?: boolean;
}

export const AnswerOptions: React.FC<AnswerOptionsProps> = ({
  answers,
  selectedOption,
  onOptionClick,
  showResults = false,
}) => {
  return (
    <OptionsContainer>
      {answers.map((answer, index) => {
        const isSelected = selectedOption === answer.answer_id;
        const isCorrect = answer.correct === 1;

        const showAsCorrect = showResults && isSelected && isCorrect;
        const showAsIncorrect = showResults && isSelected && !isCorrect;
        const isCorrectAnswer = showResults && !isSelected && isCorrect;

        const className = showResults
          ? showAsCorrect
            ? 'is-correct'
            : showAsIncorrect
              ? 'is-incorrect'
              : isCorrectAnswer
                ? 'is-correct-answer'
                : ''
          : '';

        const iconClassName = showResults
          ? showAsCorrect
            ? 'is-correct'
            : showAsIncorrect
              ? 'is-incorrect'
              : isCorrectAnswer
                ? 'is-correct-answer'
                : ''
          : '';

        return (
          <OptionCard
            key={answer.answer_id}
            selected={!showResults && isSelected}
            onClick={() => !showResults && onOptionClick(answer.answer_id || 0)}
            className={`${className} ${showResults ? 'answered' : ''}`}
          >
            <OptionIcon selected={!showResults && isSelected} className={iconClassName}>
              {showAsCorrect && <img src={checkIcon} alt="Correct" />}
              {showAsIncorrect && <img src={timesIcon} alt="Incorrect" />}
              {isCorrectAnswer && <img src={checkIcon} alt="Correct Answer" />}
              {getOptionLabel(index)}
            </OptionIcon>
            <OptionText dangerouslySetInnerHTML={{ __html: answer.answer || '' }} />
          </OptionCard>
        );
      })}
    </OptionsContainer>
  );
};
